<div>
  <span *ngFor="let item of selectedItems">
    <span *ngIf="item?.description" class="info selected-items">
      <span class="item-info description">{{item.description}}</span>
    </span>
  </span>
</div>
<a (click)="showDataToIncludeForm()" class="popup-open-button operation ui-btn button-styled">{{btnTitle}}</a>

